import React from 'react';

const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  remember,
  setRemember,
  loading,
  onSubmit,
  zohoAuthUrl,
  emailId = 'login-email',
  passwordId = 'login-password',
}) => (
  <>
    <form onSubmit={onSubmit} className="login-split-form">
      <div className="login-split-field">
        <label htmlFor={emailId}>Email</label>
        <input
          id={emailId}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Please enter your email"
          required
          autoComplete="email"
        />
      </div>

      <div className="login-split-field">
        <label htmlFor={passwordId}>Password</label>
        <div className="login-split-password">
          <input
            id={passwordId}
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Please enter your password"
            required
            autoComplete="current-password"
          />
          <button
            type="button"
            className="login-split-eye"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <i className={`ti ${showPassword ? 'ti-eye-off' : 'ti-eye'}`} />
          </button>
        </div>
      </div>

      <div className="login-split-row">
        <label className="login-split-check">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          <span>Remember me</span>
        </label>
      </div>

      <button type="submit" className="login-split-submit" disabled={loading}>
        {loading ? 'Signing in…' : 'LOGIN'}
      </button>
    </form>

    <p className="login-split-session-note">Session stays active for 24 hours (password &amp; Zoho)</p>

    <div className="login-split-divider"><span>OR</span></div>
    <a href={zohoAuthUrl} className="login-split-zoho">
      <span className="login-split-zoho-icon">Z</span>
      Sign in with Zoho
    </a>
  </>
);

export default LoginForm;
